import { useCallback, useSyncExternalStore } from 'react'
import { useSelector } from 'react-redux'
import { useFeatureFlagEnabled, usePostHog } from 'posthog-js/react'

import { useAccessKey } from './useAccess'

import { getImpersonation, subscribeImpersonation } from '@/lib/impersonation'
import { selectCurrentEnterprise, selectCurrentUserId, selectIsSuperAdmin } from '@/store/features/user/userSlice'

export const API_KEY_MANAGEMENT_FLAG = 'public-api-key-management'

export const useApiKeyManagementAccess = () => {
  const userId = useSelector(selectCurrentUserId) ?? ''
  const enterprise = useSelector(selectCurrentEnterprise)
  const isSuperAdmin = useSelector(selectIsSuperAdmin)
  const flag = useFeatureFlagEnabled(API_KEY_MANAGEMENT_FLAG)
  const posthog = usePostHog()
  const subscribe = useCallback((notify: () => void) => posthog?.onFeatureFlags(notify) ?? (() => undefined), [posthog])
  const distinctId = useSyncExternalStore(subscribe, () => posthog?.get_distinct_id() ?? '')
  const isImpersonating = useSyncExternalStore(subscribeImpersonation, getImpersonation) !== null
  const isEligible = Boolean(userId && enterprise?.id) && isSuperAdmin && !isImpersonating
  const access = useAccessKey('access.public-api-key-management', isEligible && flag === true)
  const isPending =
    isEligible && flag !== false && (flag === undefined || distinctId !== userId || access.status === 'pending')
  const isEnabled = isEligible && !isPending && flag === true && (access.status !== 'ready' || access.enabled)

  return { isEnabled, isPending, userId, enterpriseId: enterprise?.id ?? '' }
}
